var exports = {
  "kL": "x14bf3cd8--ce3d85--container",
  "BJ": "x14bf3cd8--ce3d85--form-content",
  "Lh": "x14bf3cd8--ce3d85--form-content-item",
  "Fo": "x14bf3cd8--ce3d85--form-content-area-item",
  "VF": "x14bf3cd8--ce3d85--form-content-section-item",
  "Ro": "x14bf3cd8--ce3d85--form-content-flat-number",
  "Qn": "x14bf3cd8--ce3d85--form-content-house-area",
  "iO": "x14bf3cd8--ce3d85--form-content-newbuilding-item",
  "ZZ": "x14bf3cd8--ce3d85--newbuilding-name",
  "mb": "x14bf3cd8--ce3d85--form-content-subscribe-item",
  "Tn": "x14bf3cd8--ce3d85--form-content-flat-items",
  "Gu": "x14bf3cd8--ce3d85--form-content-room-number-items",
  "$v": "x14bf3cd8--ce3d85--form-content-suburban-items",
};

module.exports = exports;
